/** @jsx jsx */
import PropTypes from "prop-types"
import { jsx, Styled } from "theme-ui"

export default function Subtitle({ children }) {
  return (
    <Styled.h2
      sx={{
        textAlign: "left",
        fontSize: [5, 7, 7],
        fontWeight: "bold",
        color: "black",
        lineHeight: 1.1,
      }}
    >
      {children}
    </Styled.h2>
  )
}

Subtitle.propTypes = {
  children: PropTypes.node.isRequired,
}
